var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSingleLineA(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.11019 18.5C3.59019 18.5 4.02018 18.2 4.17019 17.75L5.18019 14.92H10.8302L11.8202 17.74C11.9802 18.2 12.4102 18.5 12.8902 18.5C13.6802 18.5 14.2202 17.71 13.9402 16.98L9.69018 5.67C9.43018 4.97 8.75019 4.5 8.00019 4.5C7.25019 4.5 6.57019 4.97 6.31019 5.67L2.06018 16.98C1.78018 17.71 2.33019 18.5 3.11019 18.5ZM7.94018 7.1H8.06019L10.0902 12.89H5.91018L7.94018 7.1Z",
    fill: "#3C3C43",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.94043 2C1.39043 2 0.94043 1.55 0.94043 1C0.94043 0.450001 1.39043 0 1.94043 0H13.9404C14.4904 0 14.9404 0.450001 14.9404 1C14.9404 1.55 14.4904 2 13.9404 2H1.94043Z",
    fill: "#3C3C43",
    fillOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSingleLineA);
export default __webpack_public_path__ + "static/media/icon_single_line_a.53106b32aa5456d98f3e9ff39a637e13.svg";
export { ForwardRef as ReactComponent };